import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { LoginContainerComponent } from '@connect-services/client/components/login-container/login-container.component';
import { PasswordRulesVerificationComponent } from '@connect-services/client/components/password-rules-verification/password-rules-verification.component';
import { VersionComponent } from '@connect-services/client/components/version/version.component';
import { AbstractSecurityComponent } from '@connect-services/client/pages/security/abstract-security/abstract-security.component';
import { CapitalizePipe } from '@connect-services/client/pipes/capitalize.pipe';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { ForgotPasswordFormGroup, SecurityFormField } from '@shared/client/models/form.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CapitalizePipe,
        LoadingComponent,
        LoginContainerComponent,
        PasswordRulesVerificationComponent,
        RessourcesModule,
        VersionComponent,
    ],
    selector: 'app-forgot-password',
    styleUrl: '../abstract-security/abstract-security.component.scss',
    templateUrl: '../abstract-security/abstract-security.component.html',
})
export class ForgotPasswordComponent extends AbstractSecurityComponent {
    public override actionLabel = 'sendResetPassword';
    public override fieldNames = [SecurityFormField.EMAIL];
    public override readonly formGroup: WritableSignal<ForgotPasswordFormGroup> = signal<ForgotPasswordFormGroup>(
        {} as ForgotPasswordFormGroup,
    );
    public override hasBackNavigationButton = true;
    public override title = 'enterIdentifierToReset';

    protected override initForm(): ForgotPasswordFormGroup {
        return new ForgotPasswordFormGroup({
            [SecurityFormField.EMAIL]: new FormControl<string>('', {
                nonNullable: true,
                validators: [Validators.email, Validators.required],
            }),
        });
    }

    protected preInit(): void {}

    protected override async submitAction(): Promise<void> {
        const formControls = this.formGroup().controls;
        await this.securityService.forgotPassword(formControls[SecurityFormField.EMAIL].value);
    }
}
